<script>
	import { onMount } from 'svelte';
	import { getText } from '../../../../share/utils';

	import Slider from "../../Slider.svelte";

	export let isRightSide;
	export let pageContentIndex;

	onMount(() => {
		window.addEventListener('resize', () => {
			document.querySelector('.fuckup_slider')
		})
	})
</script>

<div class="flex structure">
	<div class="flex col structure-4">
		<div class="flex element">
			<img loading="lazy" alt="FuckUp - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/300likes_2.webp">
		</div>
		<div class="flex element">
		</div>
	</div>
</div>
<div class="fuckup_slider">
	<Slider {isRightSide} {pageContentIndex}>
		<div>
			<img loading="lazy" alt="FuckUp - Sommerpause - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/FUNC_Sommerpause.webp"/>
		</div>
		<div>
			<img loading="lazy" alt="FuckUp - Cover-April - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/FB-TW_Cover_April_2016ver.webp"/>
		</div>
		<div>
			<img loading="lazy" alt="FuckUp - Chemnitz - Design" src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/mai_func_chemnitz.webp"/>
		</div>
	</Slider>
</div>

<div class="flex structure">
	<div class="flex col structure-5">
		<div class="flex element">
			<img loading="lazy" alt="FuckUp - Sold out - Design"
				 src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/soldOut3.webp"/>
		</div>
		<div class="flex element">
			<img loading="lazy" alt="FuckUp - 200 Likes Teddy - Design"
				 src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/200_likes_teddy.webp"/>
		</div>
	</div>

	<div class="flex col structure-6">

		<div class="flex element">
			<div class="text">
				<h2 class="caption">{getText("14.02.08_InlineFuckUp_h2")}</h2>
				<p class="caption">{getText("14.02.09_InlineFuckUp_caption")}</p>
			</div>
		</div>
		<div class="flex row structure-6-1">

			<div class="flex element">
				<img loading="lazy" alt="FuckUp - Flowers - Design"
					 src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/func-flowers-1.webp"/>
			</div>
		</div>

		<div class="flex structure-6-2">
			<div class="flex element">
				<img loading="lazy" alt="FuckUp - Lovoo - Design"
					 src="./../img/14.Weltweit_Regional/02.kulturhauptstadt/Inline_FuckUp/LAY_lovoo_FU.gif"/>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/variables";
	@import "../../../../style/mixins";

	.flex {
		display: block;
		box-sizing: border-box;

		@include for-tablet-portrait-up {
			display: flex;
		}
	}

	.row {
		flex-flow: row wrap;
	}

	.col {
		flex-direction: column;
	}

	.element {
		min-width: 100px;
	}

	.structure {
		flex-wrap: wrap;
	}

	.structure-4 {
		flex: 1;
		//flex-shrink: 1;
		width: auto;
		margin-bottom: $media-gap;

		@include for-tablet-landscape-up {
			margin-top: 0;
			margin-right: $media-gap;
		}

	}

	.structure-5 {
		flex: 1;
		width: auto;
		margin-bottom: $media-gap;

		@include for-tablet-portrait-up {
			margin-top: 0;
			margin-right: $media-gap;
		}
	}

	.structure-6 {
		flex: 1;
		width: auto;
		margin-bottom: $spacing-mobile;

		@include for-tablet-portrait-up {
			justify-content: start;
		}
	}

	.structure-6-1 {
		justify-content: center;

		@include for-tablet-portrait-up {
			justify-content: flex-start;
			flex-flow: row nowrap;
		}

		.halfpage:first-of-type {
			@include for-tablet-portrait-up {
				margin: 0 $media-gap $media-gap 0;
			}
		}
	}

	.structure-4,
	.structure-5,
	.structure-6 {
		img {
			width: 100%;
			height: auto;
		}
	}

	.structure-5,
	.structure-6 {
		.element:first-of-type {
			width: 100%;
			margin-bottom: $media-gap;
		}
	}

	.fuckup_slider {
		margin-bottom: $media-gap;

		:global(.sc-carousel__carousel-container) {
			display: grid;
		}
		:global(.sc-carousel__pages-container) {
			height: max-content;
		}
		:global(.sc-carousel__pages-container div) {
			min-width: 100% !important;
			height: fit-content;
			line-height: 0;
		}

		:global(.sc-carousel__pages-container img) {
			position: relative;
			top: 0;
			transform: unset;
		}
		:global(.sc-carousel-dots__container) {
			margin: px-to-rem(-50) auto auto;
		}
	}
</style>
